import React from 'react';
import {
    Box, Typography, Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow, CircularProgress,
} from '@mui/material';

const formatPrice = (val) => val != null ? `$${Number(val).toFixed(2)}` : '-';
const formatPercent = (val) => val != null ? `${Number(val).toFixed(2)}%` : '-';
const formatDate = (val) => val ? new Date(val).toLocaleDateString() : '-';
const formatDateTime = (val) => val ? new Date(val).toLocaleString() : '-';
const formatNumber = (val) => val != null ? Number(val).toLocaleString() : '-';

const SectionTitle = ({ children }) => (
    <Typography variant="h6" sx={{ mb: 2, mt: 3, fontWeight: 600, fontSize: '1rem' }}>{children}</Typography>
);
const EmptyState = ({ message }) => (
    <Box sx={{ py: 4, textAlign: 'center' }}><Typography color="text.secondary">{message || 'No data available'}</Typography></Box>
);
const TabLoading = () => (
    <Box sx={{ py: 4, textAlign: 'center' }}><CircularProgress /></Box>
);

const SeasonalsTab = ({ data, loading, error }) => {
    if (loading) return <TabLoading />;
    if (error) return <EmptyState message={error} />;
    if (!data) return <EmptyState />;

    const {
        monthly_returns = [],
        quarterly_returns = [],
    } = data;

    const returnColor = (val) => {
        if (val == null) return 'inherit';
        return Number(val) >= 0 ? 'success.main' : 'error.main';
    };

    return (
        <Box>
            {/* Monthly Returns */}
            <SectionTitle>Monthly Returns</SectionTitle>
            {monthly_returns.length === 0 ? <EmptyState message="No monthly return data available" /> : (
                <TableContainer>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>Month</TableCell>
                                <TableCell align="right">Avg Return</TableCell>
                                <TableCell align="right">Positive Years</TableCell>
                                <TableCell align="right">Negative Years</TableCell>
                                <TableCell align="right">Total Years</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {monthly_returns.map((row, idx) => (
                                <TableRow key={idx}>
                                    <TableCell>{row.month_name || '-'}</TableCell>
                                    <TableCell align="right" sx={{ color: returnColor(row.avg_return), fontWeight: 600 }}>
                                        {formatPercent(row.avg_return)}
                                    </TableCell>
                                    <TableCell align="right">{formatNumber(row.positive_years)}</TableCell>
                                    <TableCell align="right">{formatNumber(row.negative_years)}</TableCell>
                                    <TableCell align="right">{formatNumber(row.total_years)}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}

            {/* Quarterly Returns */}
            <SectionTitle>Quarterly Returns</SectionTitle>
            {quarterly_returns.length === 0 ? <EmptyState message="No quarterly return data available" /> : (
                <TableContainer>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>Quarter</TableCell>
                                <TableCell align="right">Avg Return</TableCell>
                                <TableCell align="right">Total Years</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {quarterly_returns.map((row, idx) => (
                                <TableRow key={idx}>
                                    <TableCell>{row.quarter_name || '-'}</TableCell>
                                    <TableCell align="right" sx={{ color: returnColor(row.avg_return), fontWeight: 600 }}>
                                        {formatPercent(row.avg_return)}
                                    </TableCell>
                                    <TableCell align="right">{formatNumber(row.total_years)}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}
        </Box>
    );
};

export default SeasonalsTab;
